import React, { useState } from 'react';
const SandboxBIReport = () => {
    const url = import.meta.env.VITE_POWER_BI_URL || '';
    const [tabTitle, setTabTitle] = useState(document.title);
    document.title = 'Load Report';
    return <iframe style={{ width: '100%', height: 'calc(100vh - 100px)' }} src={url} frameBorder="0"></iframe>;
};

export default SandboxBIReport;
